export const ACTION_LOAD_BAR_CHART = 'ACTION_LOAD_BAR_CHART';
export const ACTION_LOAD_RADIAL_CHART = 'ACTION_LOAD_RADIAL_CHART';
export const ACTION_LOAD_COUNTERS = 'ACTION_LOAD_COUNTERS';
export const ACTION_UPDATE_PARAMS = 'ACTION_UPDATE_PARAMS';
